import styled from 'styled-components';

export const Container = styled.div`
  position: absolute;
  bottom: 2px;
  font-size: 0.9em;

  @media (max-width: 992px) {
    position: relative;
  }

  button {
    font-size: 1em;
  }
`;
